import { ref } from 'vue';

export const useWMyAppDropdown = () => {
  const isFold = ref(true);

  /** 切换 isFold */
  const toggleIsFolder = () => {
    isFold.value = !isFold.value;
  };

  return {
    isFold,
    toggleIsFolder,
  };
};
